/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import SectionNav from 'components/section-nav';
import NavTabs from 'components/section-nav/tabs';
import NavItem from 'components/section-nav/item';

/**
 * Style dependencies
 */
import './styles.scss';

const Navigation = (props) => {

    /*
    <NavItem path={'/connections/' + props.connectionId + '/resources'} selected={props.section === 'resources'}>
        Resources
                    </NavItem>
        <NavItem path={'/connections/' + props.connectionId + '/tools'} selected={props.section === 'tools'}>
            Tools
                    </NavItem>
    */
    return (
        <Box>
            <SectionNav>
                <NavTabs>
                    <NavItem path={'/connections/' + props.connectionId} selected={props.section === 'home'}>
                        Setup
                    </NavItem>
                    <NavItem
                        path={'/connections/' + props.connectionId + '/preferences'}
                        selected={props.section === 'preferences'}
                    >
                        Preferences
                    </NavItem>
                    <NavItem path={'/connections/' + props.connectionId + '/locations'} selected={props.section === 'locations'}>
                        Locations
                    </NavItem>
                    <NavItem path={'/connections/' + props.connectionId + '/sales'} selected={props.section === 'sales'}>
                        Sales
                    </NavItem>
                    <NavItem path={'/connections/'+ props.connectionId +'/syncs'} selected={props.section === 'syncs'}>
                        Syncs
                    </NavItem>
                    <NavItem path={'/connections/' + props.connectionId + '/resources'} selected={props.section === 'resources'}>
                        Resources
                    </NavItem>
                    <NavItem path={'/connections/' + props.connectionId + '/images'} selected={props.section === 'images'}>
                        Images
                    </NavItem>
                </NavTabs>
            </SectionNav>
        </Box>
    );
};

export default Navigation;
